<template>
    <div>
        <b-form>
            <div class="ssrv-header-0">
                <div class="ssrv-sub-hdr-1">
                    <div class="ssrv-hdr-1">
                    </div>
                    <h1  style="text-align: center">
                        {{ $t('pages.app.orgadminworkflow.acceptcert') }}
                    </h1>
                </div>
            </div>
            <div class="ssrv-top-0">
                <div class="ssrv-1">
                    <div class="ssrv-hdr-0">
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement2') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement3') }}
                        </div>
                    </div>
                </div>
                <br>
                <div>
                    <div class="ssrv-1">
                        <div class="ssrv-1">
                            <div class="ssrv-1">
                                <div class="ssrv-1">
                                    <b-form-checkbox v-model="saveDetails.termsAgreed" class="ssrv-form-control" v-on:blur="offFocus('termsAgreed')">{{ $t('pages.app.orgadminworkflow.acceptcert')}}</b-form-checkbox>
                                </div>
                                <div class="ssrv-50" v-if="showErrorField()" style="font-color:red;color:red">{{ validProperties.termsAgreed }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="ssrv-1">
                        <div class="ssrv-1">
                        </div>
                    </div>
                </div>
                <div class="ssrv-space"></div>

            </div>
            <br>
            <div class="ssrv-0">
                <div class="ssrv-3">
                    <b-button @click="save" :block="true" size="lg" variant="primary" active-class="ssrv-form-button" class="ssrv-form-button" :disabled="(this.saveDetails.termsAgreed === undefined || !this.saveDetails.termsAgreed) || this.saveDetails.signature !== undefined">
                        {{$t("common.form.submit")}}
                    </b-button>
                </div>
                <div class="ssrv-3">
                    <div class="ssrv-50" style="font-color:red;color:red">{{this.processTask}}</div>
                </div>
            </div>
            <!-- modal to show a user successfully sent their account creation request -->
            <b-modal id="successModal"
                     ref="successModal"
                     :title="this.$t('pages.orgadmin.submitTitle')">

                <div>
                    {{ this.popupState }}
                </div>

                <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-btn type="button" @click="successRequest">{{$t('common.form.confirm')}}</b-btn>
                    </div>
                </div>
            </b-modal>
        </b-form>

    </div>
</template>

<script>
import _ from 'lodash';

/**
     * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
     *
     **/
export default {
    name: 'User-Details',
    components: {

    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    data () {
        var data = {
            userDetails: {
                userName: '',
                description: '',
                termsAgreed: false
                // signature: ''
            },
            saveDetails: {
                userName: '',
                description: '',
                termsAgreed: false
                // signature: ''
            },
            userPreferences: {},
            isSocialReg: _.get(this.selfServiceDetails, 'tag') !== 'initial',
            validProperties: {
                userName: '',
                description: ''
            },
            id: this.$route.params.resourceId,
            user: this.$root.userStore.state,
            processTask: '',
            sigMatch: false,
            defName: 'BasicUserPromotionRequest3',
            popupState: this.$t('pages.orgadmin.submit')
        };

        return data;
    },
    methods: {
        getData () {
            let details = _.clone(this.saveDetails);

            return {
                user: details
            };
        },

        // Add additional frontend checks for field validation here
        calculateValidation (property) {
            let validators = [];

            if (property.required) {
                validators.push('required');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                _.each(property.policies, (policy) => {
                    if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    }
                });
            }

            return validators.join('|');
        },

        showErrorField () {
            if (this.companyExists === false) {
                if (this.companyIdType === 'RR' || this.companyIdType === 'CL') {
                    return false;
                }
            }
            return true;
        },

        offFocus (property) {

        },

        save () {
            this.processTask = '';
            var wfdata, loginServiceInstance, result;
            // loginServiceInstance = this.getRequestService({
            //     headers: {
            //         'X-OpenIDM-NoSession': false,
            //         'X-OpenIDM-Password': this.encodeRFC5987IfNecessary(this.password),
            //         'X-OpenIDM-Username': this.encodeRFC5987IfNecessary(this.username)
            //     }
            // });
            // loginServiceInstance.get('managed/user');
            // var loggedInUser, formUser, axios, config; // wfdata, config;
            /* if (this.saveDetails.signature !== undefined) {
                loginServiceInstance = this.getRequestService({
                    headers: {
                        // 'X-OpenIDM-NoSession': false,
                        'X-OpenIDM-Password': 'openidm-admin',
                        'X-OpenIDM-Username': 'openidm-admin',
                        'X-OpenIDM-NoSession': 'true',
                        'Content-Type': 'application/json'
                    }
                });
                loginServiceInstance.get('managed/user/' + this.user['userId'])
                    .then((loggedInUserResponse) => {
                        var result = loggedInUserResponse.data, signature;
                        console.log('OUT: ' + result.promotingAdmin);
                        if (result.promotingAdmin !== undefined && result.promotingAdmin.length > 0) {
                            signature = result.givenName + ' ' + result.sn;
                            console.log('Out2 ' + signature + ' - ' + this.saveDetails.signature);
                            if (this.saveDetails.signature === signature) {
                                this.sigMatch = true;
                                console.log('Process Task true!!!');
                                console.log('Call before Workflow: ' + `${this.saveDetails.termsAgreed}` + ' - ' + `${this.saveDetails.signature}`);
                                let termsAgreedVal = (this.saveDetails.termsAgreed) ? 'Yes' : 'No';
                                wfdata = JSON.stringify([{
                                    'operation': 'replace',
                                    'field': '/termsAgreed',
                                    'value': `${termsAgreedVal}`
                                },
                                {
                                    'operation': 'replace',
                                    'field': '/signedCertification',
                                    'value': 'Yes'
                                }
                                ]);
                                loginServiceInstance.patch('managed/user/' + this.user['userId'], wfdata).then((updatedUserResponse) => {
                                    console.log('Updated User! ' + JSON.stringify(updatedUserResponse));
                                }).catch((error) => {
                                    console.log('Error: ' + error);
                                    this.popupState = this.$t('pages.orgadmin.fail');
                                });
                            } else {
                                this.processTask = this.$t('pages.notFound.orgAdminUser');
                            }
                        } else {
                            this.popupState = this.$t('pages.orgadmin.fail');
                        }
                        this.$refs.successModal.show();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                console.log('This is after the api call is made');
            } */
            loginServiceInstance = this.getRequestService({
                headers: {
                    // 'X-OpenIDM-NoSession': false,
                    // 'X-OpenIDM-Password': 'openidm-admin',
                    // 'X-OpenIDM-Username': 'openidm-admin',
                    'X-OpenIDM-NoSession': 'true',
                    'Content-Type': 'application/json'
                }
            });
            loginServiceInstance.get('managed/user/' + this.user['userId'])
                .then((loggedInUserResponse) => {
                    result = loggedInUserResponse.data;
                    console.log('OUT: ' + result.promotingAdmin);
                    if (result.promotingAdmin !== undefined && result.promotingAdmin.length > 0) {
                        // console.log('Process Task true!!!');
                        // console.log('Call before Workflow: ' + `${this.saveDetails.termsAgreed}`);
                        let termsAgreedVal = (this.saveDetails.termsAgreed) ? 'Yes' : 'No';
                        wfdata = JSON.stringify([{
                            'operation': 'replace',
                            'field': '/termsAgreed',
                            'value': `${termsAgreedVal}`
                        },
                        {
                            'operation': 'replace',
                            'field': '/signedCertification',
                            'value': 'Yes'
                        }
                        ]);
                        loginServiceInstance.patch('managed/user/' + this.user['userId'], wfdata).then((updatedUserResponse) => {
                            // console.log('Updated User! ' + JSON.stringify(updatedUserResponse));
                        }).catch((error) => {
                            error = undefined;
                            // console.log('Error: ' + error);
                            this.popupState = this.$t('pages.orgadmin.fail');
                        });
                    } else {
                        this.popupState = this.$t('pages.orgadmin.fail');
                    }
                    this.$refs.successModal.show();
                })
                .catch(function (error) {
                    error = undefined;
                    // console.log(error);
                });
            // console.log('This is after the api call is made');
        },

        successRequest () {
            this.$refs.successModal.hide();
            this.$router.push({
                name: 'Dashboard'
            });
        },

        isValid () {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        },

        invokeWorkflow (payload, config) {
            this.makeUpdateRequest('selfservice/user', payload, config);
        },
        makeUpdateRequest (endpoint, payload, config = {}) {
            /* istanbul ignore next */
            let successMsg = config.successMsg || this.$t('common.user.profile.updateSuccess'),
                userId = this.$root.userStore.state.userId,
                selfServiceInstance = this.getRequestService({
                    headers: config.headers
                });

            /* istanbul ignore next */
            selfServiceInstance.patch(`${endpoint}/${userId}`, payload).then((response) => {
                this.$root.userStore.setProfileAction(response.data);
                this.displayNotification('success', successMsg);

                if (config.onSuccess) {
                    config.onSuccess();
                }
            })
                .catch((error) => {
                    /* istanbul ignore next */
                    let errorMsg = config.errorMsg || error.response.data.message;
                    this.displayNotification('error', errorMsg);

                    if (config.onError) {
                        config.onError(error);
                    }
                });
        }
    }
};
</script>

<style scoped lang="scss">
.ssrv-form-button {
    background-color: #0054AD;
}
</style>
